<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full space-y-8">
      <div>
        <!-- <img class="mx-auto h-12 w-auto" src="https://tailwindui.com/img/logos/workflow-mark-blue-600.svg" alt="Workflow" /> -->
        <div class="text-5xl text-center">
          <font-awesome-icon class="text-red-600" :icon="['fas', 'dice']" />
        </div>
        <h2 class="mt-6 text-center text-2xl font-extrabold text-gray-900">
          REDTABLE CMS
        </h2>
        <p class="mt-2 text-center text-sm text-gray-600">
          Sign in to your account
        </p>
      </div>
      <div class="rounded-md bg-red-50 p-4" v-show="errMessage">
        <div class="flex">
          <div class="flex-shrink-0">
            <XCircleIcon class="h-5 w-5 text-red-400" aria-hidden="true" />
          </div>
          <div class="ml-3">
            <h3 class="text-sm font-medium text-red-800">
              {{ errMessage }}
            </h3>
          </div>
        </div>
      </div>
      <form @submit.prevent="login" class="mt-8 space-y-6" action="#" method="POST">
        <input type="hidden" name="remember" value="true" />
        <div class="rounded-md shadow-sm -space-y-px">
          <div>
            <label for="username" class="sr-only">{{ $t("messages.logIn.username") }}</label>
            <input v-model="form.username" id="username" name="username" type="username" autocomplete="username"
              required=""
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
              placeholder="Username" :disabled="isAuthenticated" />
          </div>
          <div>
            <label for="password" class="sr-only">{{ $t("messages.logIn.password") }}</label>
            <input v-model="form.password" id="password" name="password" type="password" autocomplete="password"
              required=""
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
              placeholder="Password" :disabled="isAuthenticated" />
          </div>
        </div>

        <div>
          <button type="submit" :class="[
            'group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white ',
            isAuthenticated
              ? 'bg-gray-400 cursor-default'
              : 'bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500',
          ]" :disabled="isAuthenticated">
            <span class="absolute left-0 inset-y-0 flex items-center pl-3">
              <LockClosedIcon :class="[
                'h-5 w-5',
                isAuthenticated
                  ? 'bg-gray-400'
                  : 'text-blue-500 group-hover:text-blue-400',
              ]" aria-hidden="true" />
            </span>
            <span v-show="!isWorking">{{ $t("messages.logIn.signIn") }}</span>
            <font-awesome-icon v-show="isWorking" class="text-white" :icon="['fas', 'circle-notch']" spin />
          </button>
        </div>

        <div class="flex items-center justify-center mt-1">
          <div class="text-sm">
            <a href="#" class="font-medium text-blue-600 hover:text-blue-500">
              {{ $t("messages.logIn.forgotPassword") }}
            </a>
          </div>
        </div>
      </form>
      <div v-if="isAuthenticated" class="flex-col flex gap-y-4">
        <div class="flex flex-row flex-nowrap gap-2">
          <maz-phone-number-input v-if="!isDisablePhone" v-model="authenticate.phone" default-country-code="TH"
            :disabled="isDisablePhone" />
          <button v-if="!isDisablePhone" :class="[
            'relative w-20 flex py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white',
            isDisablePhone
              ? 'cursor-default bg-gray-400'
              : 'hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-400 bg-blue-500',
          ]" :disabled="isDisablePhone" @click="onSendphone">
            <span class="m-auto">{{ $t("messages.logIn.send") }}</span>
          </button>
        </div>
        <span v-if="isOTPOpen && isDisablePhone">
          {{ $t("messages.logIn.inputSmsOtp") }}
        </span>
        <input v-if="isOTPOpen && isDisablePhone" v-model="authenticate.code" id="code" name="code" type="text" autocomplete="" required="" maxlength="4"
          class="appearance-none rounded-none relative w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
          :placeholder="$t('messages.logIn.otp')" />
        <button v-if="isOTPOpen && isDisablePhone"
          class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          @click="onSubmitOTP">
          <span>{{ $t("messages.logIn.submit") }}</span>
        </button>
        <span v-if="isQrOTPOpen">
          {{ $t("messages.logIn.scanQrWithAppMessage") }}
        </span>
        <img v-if="isTOTPOpen" :src="authenticate.qrcode">
        <span v-if="isTOTPOpen">
          {{ $t("messages.logIn.inputTotp") }}
        </span>
        <span v-if="currentAttempts > 0" class="text-red-600">
          ใส่ผิดไปแล้ว {{ currentAttempts }} ครั้ง
        </span>
        <input v-if="isTOTPOpen" v-model="authenticate.topt" id="topt" name="topt" type="text" autocomplete="" required="" maxlength="6"
          class="appearance-none rounded-none relative w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
          :placeholder="$t('messages.logIn.totpCode')" />
        <button v-if="isTOTPOpen"
          class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          @click="onSubmitTOTP">
          <span>{{ $t("messages.logIn.submit") }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, inject, ref } from "vue";
import { LockClosedIcon, XCircleIcon } from "@heroicons/vue/solid";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import jwt_decode from "jwt-decode";
import * as publicIp from "public-ip";
import QRCode from 'qrcode'

export default {
  components: {
    LockClosedIcon,
    XCircleIcon,
  },
  setup() {
    const axios = inject("$axios");
    const store = useStore();
    const router = useRouter();
    let isWorking = ref(false);
    let errMessage = ref("");
    let currentAttempts = ref(0);

    onMounted(() => {
      if (store.state.user.phone) {
        authenticate.value.phone = store.state.user.phone;
      }
      if (store.state.user.token) router.push({ name: "Home" });
    });

    let form = {
      username: null,
      password: null,
      app: process.env.VUE_APP_OPERATOR_APP_ID,
    };

    const isDisablePhone = ref(false);
    const isOTPOpen = ref(false);
    const isTOTPOpen = ref(false);
    const isQrOTPOpen = ref(false);
    const isAuthenticated = ref(false);
    const signInDisable = ref(false);
    const authenticate = ref({
      phone: null,
      sessionId: null,
      ref: null,
      code: null,
      topt: null,
      secret: null,
      qrcode: null
    });

    const login = async () => {
      errMessage.value = "";
      isWorking.value = true;
      if (signInDisable.value) {
        return;
      }
      signInDisable.value = true;
      publicIp.v4().then(async (ip) => {
        store.commit("updateIpAddress", ip);

        await axios
          .post(
            process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/auth/admin-login",
            form,
            {
              headers: { "x-cm-forwarded-for": store.state.user.ip },
            }
          )
          .then(({ data }) => {
            if (data.token) {
              userLoggedIn(data);
            } else {
              // send phone = enable otp
              // next step check secret
              // if not have phone register phone with otp
              // if have secret open field for topt
              // if not have secret open qr
              if (data.secret) {
                (authenticate.value.sessionId = data?.session_id),
                  (isAuthenticated.value = true),
                  (authenticate.value.secret = data?.secret),
                  (isDisablePhone.value = true);
                onCheckTOTP()
              } else {
                if (data.phone) {
                  authenticate.value.phone = `${"******" + data?.phone}`;
                  (authenticate.value.sessionId = data?.session_id),
                    (isOTPOpen.value = true),
                    (isDisablePhone.value = true),
                    (isAuthenticated.value = true);
                  onSendphone();
                } else {
                  (authenticate.value.sessionId = data?.session_id),
                    (isOTPOpen.value = true),
                    (isAuthenticated.value = true),
                    (isDisablePhone.value = false);
                }
              }

              // if (data.phone) {
              //   authenticate.value.phone = `${"******" + data?.phone}`;
              //   (authenticate.value.secret = data?.secret),
              //   (authenticate.value.sessionId = data?.session_id),
              //       (isDisablePhone.value = true),
              //       (isAuthenticated.value = true);
              //   onCheckTOTP();
              //   //onSendphone();
              //   // open field for validate number
              //   // open field qr if no secret
              // }else{
              //       (authenticate.value.sessionId = data?.session_id),
              //       (isOTPOpen.value = true),
              //       (isAuthenticated.value = true),
              //       (isDisablePhone.value = false);
              // }
            }
          })
          .catch((err) => {
            switch (err.response.data.message) {
              case "INVALID_CREDENTIALS":
                errMessage.value = "ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง";
                break;
              case "INVALID_MOBILE_PHONE":
                errMessage.value = "เบอร์มือถือไม่ถูกต้อง";
                break;
              default:
                errMessage.value = "เกิดข้อผิดพลาดกับระบบ";
                break;
            }
            signInDisable.value = false;
            isWorking.value = false
          });
      });

      isWorking.value = false;
    };

    const onCheckTOTP = async () => {
      axios.post(
        process.env.VUE_APP_API_ENDPOINT +
        "/admin/api/v1/auth/admin-totp-check-attempts",
        {
          requestId: Date.now().toString(),
          requestTs: Date.now(),
          code: 'login',
          username: form.username,
          callerFunction: 'Login'
        },
        {
          headers: { "x-cm-forwarded-for": store.state.user.ip },
        }
      )
      .then(({ data }) => {
        currentAttempts.value = data.result.attempts
      })

      if (!authenticate.value.secret) {
        axios
          .post(
            process.env.VUE_APP_API_ENDPOINT +
            "/admin/api/v1/auth/admin-login-create-secret",
            {
              sessionId: authenticate.value.sessionId
            },
            {
              headers: { "x-cm-forwarded-for": store.state.user.ip },
            }
          )
          .then(({ data }) => {
            authenticate.value.secret = data.secret.base32
            QRCode.toDataURL(data.secret.otpauth_url, function (err, data_url) {
              authenticate.value.qrcode = data_url
            });
            isQrOTPOpen.value = true
          })
          .catch((err) => {
            errMessage.value = "เกิดข้อผิดพลาดกับระบบ";
          })
      }
      isTOTPOpen.value = true
      /*
      * check secret
      * */
    }

    const onSubmitTOTP = async () => {
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT +
          "/admin/api/v1/auth/admin-login-totp-confirm",
          {
            sessionId: authenticate.value.sessionId,
            secret: authenticate.value.secret,
            code: authenticate.value.topt
          },
          {
            headers: { "x-cm-forwarded-for": store.state.user.ip },
          }
        )
        .then(({ data }) => {
          userLoggedIn(data);
          isWorking.value = false;
        })
        .catch((err) => {
          if (err?.response?.data?.isBlackList) {
            store.commit("removeUserInfo");
            store.commit("removeOperators");
            router.push({ name: "Login" });
            window.location.reload();
          } else if (err?.response?.data?.attempts){
            console.log(err.response.data.attempts);
            currentAttempts.value = err.response.data.attempts
          }
          isWorking.value = false;
          errMessage.value = "รหัส Google Authenticator ไม่ถูกต้อง";
        })
    }

    const onSendphone = async (isPhone = false) => {
      const form = isPhone
        ? {
          sessionId: authenticate.value.sessionId,
          phone: authenticate.value.phone,
        }
        : { sessionId: authenticate.value.sessionId };
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT +
          "/admin/api/v1/auth/admin-login-otp-request",
          form,
          {
            headers: { "x-cm-forwarded-for": store.state.user.ip },
          }
        )
        .then(({ data }) => {
          authenticate.value.ref = data.ref;
        })
        .catch((err) => {
          errMessage.value = "เกิดข้อผิดพลาดกับระบบ";

          // switch (err.response.data.message) {
          //   case 'INVALID_OTP':
          //     errMessage.value = 'รหัส OTP ไม่ถูกต้อง'
          //     break;
          //   default:
          //     errMessage.value = 'เกิดข้อผิดพลาดกับระบบ'
          //     break;
          // }
        });
      isDisablePhone.value = true;
    };

    const onSubmitOTP = async () => {
      errMessage.value = "";
      isWorking.value = true;

      const form = {
        phone: authenticate.value.phone,
        sessionId: authenticate.value.sessionId,
        ref: authenticate.value.ref,
        code: authenticate.value.code,
      };
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT +
          "/admin/api/v1/auth/admin-login-otp-confirm",
          form,
          {
            headers: { "x-cm-forwarded-for": store.state.user.ip },
          }
        )
        .then(({ data }) => {
          onCheckTOTP()

        })
        .catch((error) => {
          isWorking.value = false;
          errMessage.value = "รหัส OTP ไม่ถูกต้อง";
          isAuthenticated.value = false
        });
      isOTPOpen.value = false
      isDisablePhone.value = true
    };

    const userLoggedIn = async (data) => {
      let decode = jwt_decode(data.token);
      /// 1.send user id to gw-admin(gw-oper => gw-admin => gw-auth)
      /// 2.set permission to setUserToken
      store.commit("setUserToken", {
        token: data.token,
        userId: decode.userId,
        exp: decode.exp,
        username: decode.username,
        permissions: data.permissions,
      });

      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT +
          "/admin/api/v1/operator-admin/get-operator-profile-user",
          {
            id: decode.sub,
          },
          {
            headers: {
              "x-cm-forwarded-for": store.state.user.ip,
            },
          }
        )
        .then((getOperatorResponse) => {
          store.commit("setOperators", getOperatorResponse.data.result);
          router.push({ name: "Home" });
        })
        .catch((err) => {
          switch (err.response.data.message) {
            case "INVALID_OTP":
              errMessage.value = "รหัส OTP ไม่ถูกต้อง";
              break;
            default:
              errMessage.value = "เกิดข้อผิดพลาดกับระบบ";
              break;
          }
        });

      isWorking.value = false;
    };

    const confirm_otp = async () => {
      errMessage.value = "";
      isWorking.value = true;

      let form = {
        phone: null,
        username: null,
        refCode: null,
        otp: null,
      };

      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/auth/admin-login-confirm",
          form,
          {
            headers: { "x-cm-forwarded-for": store.state.user.ip },
          }
        )
        .then(({ data }) => {
          let decode = jwt_decode(data.token);

          store.commit("setUserToken", {
            token: data.token,
            userId: decode.userId,
            exp: decode.exp,
            username: form.username,
            permissions: decode.permissions,
          });

          axios
            .post(
              process.env.VUE_APP_API_ENDPOINT +
              "/admin/api/v1/operator-admin/get-operator-profile-user",
              {
                id: decode.sub,
              },
              {
                headers: {
                  "x-cm-forwarded-for": store.state.user.ip,
                },
              }
            )
            .then((getOperatorResponse) => {
              store.commit("setOperators", getOperatorResponse.data.result);
              router.push({ name: "Home" });
            });
        })
        .catch((err) => {
          switch (err.response.data.message) {
            case "INVALID_OTP":
              errMessage.value = "รหัส OTP ไม่ถูกต้อง";
              break;
            default:
              errMessage.value = "เกิดข้อผิดพลาดกับระบบ";
              break;
          }
        });

      isWorking.value = false;
    };

    return {
      form,
      login,
      isWorking,
      errMessage,
      onSubmitOTP,
      confirm_otp,
      onSendphone,
      authenticate,
      isDisablePhone,
      isAuthenticated,
      isQrOTPOpen,
      isTOTPOpen,
      onSubmitTOTP,
      isOTPOpen,
      currentAttempts,
    };
  },
};
</script>

<style>
.m-select-list__scroll-wrapper {
  background: white;
}

.m-input {
  background: white;
}
</style>
